import React, { useEffect, useState } from "react";
import { Button, Form, Modal } from "semantic-ui-react";
import { useMessageResources, useTextResources } from "../../../../language";
import PropTypes from "prop-types";
import { onWarning } from "../../../../components/shared/messages";
import StaticDiscountDropDown from "../../../../components/shared/StaticDiscountDropDown";
import NumericInput from "../../../../components/shared/NumericInput";
import { StaticDiscounts } from '../../../../api/services/next';

export const AddReasonCodesPopup = ({ open, onClose, onAdd, RateId, staticDiscountMappings }) => {
    const text = useTextResources();
    const message = useMessageResources();
    const [newStaticDiscountMapping, setNewStaticDiscountMapping] = useState({ Id: 0, EntityId: RateId, StaticDiscount: '' });
    const [allStaticDiscounts, setAllStaticDiscounts] = useState([]);
    const [originalStaticDiscounts, setOriginalStaticDiscounts] = useState([]);
    useEffect(() => {
        (async () => {
            let staticDiscounts = await StaticDiscounts.GetStaticDiscounts();
            setAllStaticDiscounts(staticDiscounts);
        })();
    }, []);

    useEffect(() => {
        setOriginalStaticDiscounts(staticDiscountMappings);
    }, [staticDiscountMappings]);

    const reset = () => {
        setNewStaticDiscountMapping({ Id: 0, EntityId: RateId, StaticDiscount: '' });
    }

    const onSave = () => {
        if (validate()) {
            let newStaticDiscountMappingWithDescription = {
                Id: 0,
                StaticDiscountId: newStaticDiscountMapping.StaticDiscountId,
                StaticDiscount: allStaticDiscounts.find(x => x.Id === newStaticDiscountMapping.StaticDiscountId),
                Discount: newStaticDiscountMapping.Discount <= 0 ? undefined : newStaticDiscountMapping.Discount,
                EntityId: RateId,
            };
            onAdd(newStaticDiscountMappingWithDescription);
            reset();
        }
    }

    const validate = () => {
        const doesAllFieldsPopulated = newStaticDiscountMapping.StaticDiscountId > 0 && newStaticDiscountMapping.Discount > 0;

        if (!doesAllFieldsPopulated) {
            onWarning(message("AllFieldsAreRequired"));
            return false;
        }

        let visibleStaticDiscountMappings = originalStaticDiscounts.filter(x => x.Id >= 0);
        let existingMapping = visibleStaticDiscountMappings.find(x => x.StaticDiscountId == newStaticDiscountMapping.StaticDiscountId);
        if (existingMapping) {
            onWarning(text("ReasonCodesShouldBeUnique"));
            return false;
        }

        return true;
    }

    const onCloseAction = () => {
        onClose?.();
        reset();
    }

    const setStaticDiscountId = (value) => {
        setNewStaticDiscountMapping({
            ...newStaticDiscountMapping,
            StaticDiscountId: value,
            Discount: allStaticDiscounts.find(x => x.Id === value)?.Discount
        });
    };

    const setDiscountPercent = (value) => {
        setNewStaticDiscountMapping({
            ...newStaticDiscountMapping,
            Discount: value
        });
    };

    return (
        <Modal size="tiny" open={open} onClose={onClose} dimmer centered>
            <Modal.Header>{text("AddReasonCodes")}</Modal.Header>
            <Modal.Content>
                <Form>
                    <Form.Group widths={2}>
                        <Form.Field
                            label={text('ReasonCodes')}
                            clearable
                            control={StaticDiscountDropDown}
                            onChange={(value) => setStaticDiscountId(value)}
                            value={newStaticDiscountMapping.StaticDiscountId}
                            required
                        />
                        <Form.Field
                            label={text("DiscountPercent")}
                            control={NumericInput}
                            value={(newStaticDiscountMapping.Discount > 0 ? newStaticDiscountMapping.Discount : '')}
                            onChange={(value) => setDiscountPercent(value)}
                            min={0}
                            digits={0}
                            required
                            buttonPlacement="right"
                        />
                    </Form.Group>
                </Form>
            </Modal.Content>
            <Modal.Actions>
                <Button negative onClick={onCloseAction}>
                    {text("Close")}
                </Button>
                <Button positive onClick={onSave}>
                    {text("Add")}
                </Button>
            </Modal.Actions>
        </Modal>
    );
};

AddReasonCodesPopup.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    onAdd: PropTypes.func,
    RateId: PropTypes.number,
    staticDiscountMappings: PropTypes.array,
};